import { Space, Tooltip } from "antd";
import { MdCheckCircleOutline } from "react-icons/md";
import { SlQuestion } from "react-icons/sl";

interface VerificationStatusProps {
  isVerified: boolean | null | undefined;
  showText?: boolean;
}

export const VerificationStatus: React.FC<VerificationStatusProps> = ({
  isVerified,
  showText = true,
}) => {
  if (isVerified === null || isVerified === undefined) {
    return (
      <Tooltip title="Verification status unknown">
        <Space>
          <SlQuestion style={{ color: "#faad14" }} />
          {showText && <span>Unknown</span>}
        </Space>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={isVerified ? "Verified" : "Unverified"}>
      <Space>
        {isVerified ? (
          <MdCheckCircleOutline style={{ color: "#008000" }} />
        ) : (
          <div></div>
          // <MdCheckCircleOutline style={{ color: "#ff4d4f" }} />
        )}
        {showText && (
          <span style={{ color: isVerified ? "#008000" : "#ff4d4f" }}>
            {isVerified ? "Verified" : "Unverified"}
          </span>
        )}
      </Space>
    </Tooltip>
  );
};
